import type { SVGProps } from 'react';

const SvgPluginMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 40' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_18420_5684)'>
      <path
        d='M28.4 9.59922V3.59922C28.4 2.79922 27.8 2.19922 27 2.19922C26.2 2.19922 25.6 2.79922 25.6 3.59922V9.39922H14.4V3.59922C14.4 2.79922 13.8 2.19922 13 2.19922C12.2 2.19922 11.6 2.79922 11.6 3.59922V9.59922C8.4 10.1992 6 13.1992 6 16.3992V17.9992C6 24.9992 11.6 30.5992 18.6 30.5992V36.3992C18.6 37.1992 19.2 37.7992 20 37.7992C20.8 37.7992 21.4 37.1992 21.4 36.3992V30.5992C28.4 30.5992 34 24.9992 34 17.9992V16.3992C34 12.9992 31.6 10.1992 28.4 9.59922ZM31.2 17.9992C31.2 23.3992 26.8 27.7992 21.4 27.7992H20H18.6C13.2 27.7992 8.8 23.3992 8.8 17.9992V16.3992C8.8 13.9992 10.6 12.1992 13 12.1992H27C29.4 12.1992 31.2 13.9992 31.2 16.3992V17.9992ZM21.8 19.5992C22.4 19.9992 22.6 20.5992 22.2 21.1992L21.2 23.3992C21 23.9992 20.4 24.1992 20 24.1992C20 24.1992 19.6 24.1992 19.4 24.1992C18.6 23.9992 18.4 22.9992 18.6 22.3992L19.2 21.1992L18.2 20.3992C17.6 19.9992 17.4 19.3992 17.8 18.7992L18.8 16.5992C19 15.7992 20 15.5992 20.6 15.7992C21.2 15.9992 21.6 16.9992 21.4 17.5992L20.8 18.7992L21.8 19.5992Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_18420_5684'>
        <rect width={40} height={40} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPluginMd;
